<template>
    <div>
        <b-card class="standardpage">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="'fa fa-stack-overflow text-primary'" class="mr-1"></i>
                        {{ charters.title }}
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-if="!component" class="availtable datatable">
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="release" :icon="charters.icon"
                        :toolbarlibrary="charters.toolbarlibrary" :tools="charters.tools" :badges="charters.badges"
                        :fields="charters.fields" :items="charters.items" :busy="charters.busy" :page="charters.page"
                        :selectall="charters.selectall" :showpages="false" :showrowcount="false" @click="charters_click"
                        @select="charters_select">
                    </d-table>
                </div>
            </div>

            <div class="px-3 text-primary mt-2">
                <b-row>
                    <b-col cols="auto">
                        <b-button id="release-otp" size="sm" squared :variant="'outline-primary'" class="ml-0"
                            :disabled="true" @click="release()">
                            OTP: {{ otp }}
                        </b-button>

                        <b-button class="h-28px ml-2" id="refresh-otp" size="sm" squared @click="newotp()">
                            <i class="fa fa-refresh"></i>
                        </b-button>
                        <b-tooltip target="refresh-otp" triggers="hover">Click refresh to get a new One-Time
                            Passcode if the code is
                            not readable.</b-tooltip>

                    </b-col>
                    <b-col>
                        Enter the One-Time Passcode, a correct code will enable the button
                        below, then click it to release all tickets in the selected PNRs. Use refresh to get a
                        new passcode.
                    </b-col>
                </b-row>
                <b-row class="my-4">
                    <b-col cols="12" sm="6" md="4" xl="3">
                        <b-form-group label-cols="12" label="One Time Passcode " label-size="sm"> <b-input-group
                                id="enter-otp">
                                <b-form-input type="text" v-model="otc" placeholder="Enter OTP"
                                    size="sm"></b-form-input>
                                <b-input-group-append>
                                    <b-button size="sm" variant="outline-secondary" @click="otc = null">
                                        <i class="fa fa-remove"></i>
                                    </b-button>
                                </b-input-group-append>
                                <b-tooltip target="release-otp" triggers="hover">Click this button to begin the charter
                                    release
                                    process, a
                                    confirmation email will be sent to you.</b-tooltip>

                            </b-input-group> </b-form-group>

                    </b-col>
                    <!-- <b-col cols="auto mr-2">
                        <b-form-group label-cols="12" label=" " label-size="sm"> <b-input-group>

                                <b-tooltip target="release-otp" triggers="hover">Click this button to begin the charter
                                    release
                                    process, a
                                    confirmation email will be sent to you.</b-tooltip>
                                <b-input-group-append>
                                    <b-button class="h-28px" id="refresh-otp" size="sm" squared @click="newotp()">
                                        <i class="fa fa-refresh"></i>
                                    </b-button>
                                    <b-tooltip target="refresh-otp" triggers="hover">Click refresh to get a new One-Time
                                        Passcode if the code is
                                        not readable.</b-tooltip>
                                </b-input-group-append>
                            </b-input-group> </b-form-group>

                    </b-col> -->
                    <b-col cols="12" sm="6" md="4" xl="3">
                        <b-form-group label-cols="12" label="Email To" label-size="sm">
                            <b-input-group>
                                <b-form-input type="text" v-model="emailto" placeholder="Email To"
                                    size="sm"></b-form-input>
                                <b-input-group-append>
                                    <b-button size="sm" variant="outline-secondary" @click="emailto = ''">
                                        <i class="fa fa-remove"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                        <b-form-group label-cols="12" label="Issuing Agent Initials" label-size="sm">
                            <b-input-group>
                                <b-form-input type="text" v-model="agent" placeholder="Agent" size="sm"></b-form-input>
                                <b-input-group-append>
                                    <b-button size="sm" variant="outline-secondary" @click="agent = ''">
                                        <i class="fa fa-remove"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                    </b-col>
                </b-row>
            </div>

            <!-- v-if="user.permissions.includes('charter.release')" -->
            <b-card-footer class="mt-3">
                <b-row>
                    <b-col class="text-left">
                        <b-row>
                            <b-col class="text-left">
                                <b-button :disabled="releasenotready" squared size="sm" variant="primary"
                                    @click="releaseit()" class="mr-1">
                                    <i class="fa fa-ticket"></i>
                                    Release It
                                </b-button>
                            </b-col>
                            <b-col class="text-left">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary ml-4"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="text-right">
                        <b-button squared size="sm" class="mr-0" variant="secondary" @click="$emit('discard')">
                            <i class="fa fa-chevron-left"></i>Back
                        </b-button>
                    </b-col>
                </b-row>

            </b-card-footer>

        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

export default {
    name: "CharterRelease",
    data() {
        return {
            busy: false,
            readonly: true,
            released: false,
            otp: this.$helpers.instanceid(),
            otc: null,
            emailto: null,
            agent: null,
            message: null,
            charters: {
                title: "Release Charter",
                icon: "fa fa-plane text-primary",
                debounce: 500,
                busy: false,
                selectall: false,
                page: 1,
                denied: [],
                toolbarlibrary: [],
                tools: "go,export",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-50px",
                    },
                    // {
                    //   key: "grouptype",
                    //   label: "Type",
                    //   sortable: true,
                    //   class: "text-center",
                    // },
                    {
                        key: "direction",
                        label: "Direction",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "locator",
                        label: "Locator",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "startdate",
                        label: "Departure",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            let result = "Never";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .utc(false)
                                    .format("ddd DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "routing",
                        label: "Routing",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 20) {
                                    result = result.slice(0, 17) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "flightno",
                        label: "FlightNo",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                        formatter: (value, key, item) => {
                            let result = value;
                            if (result) {
                                if (result.length > 14) {
                                    result = result.slice(0, 14) + "...";
                                }
                            }
                            return result;
                        },
                    },
                    {
                        key: "classcode",
                        label: "Class",
                        sortable: true,
                        class: "d-none d-lg-table-cell text-center",
                    },
                    {
                        key: "aircraft",
                        label: "Aircraft",
                        sortable: true,
                    },
                    {
                        key: "fare_type",
                        label: "Fare Type",
                        sortable: true,
                    },
                    {
                        key: "total",
                        label: "Total",
                        sortable: true,
                        class: "text-center",
                        totalled: true,
                        type: "int",
                        total: 0,
                    },
                    {
                        key: "booked",
                        label: "Booked",
                        sortable: true,
                        class: "text-center",
                        totalled: true,
                        type: "int",
                        total: 0,
                    },
                    {
                        key: "free",
                        label: "Free",
                        sortable: true,
                        class: "text-center",
                        totalled: true,
                        type: "int",
                        total: 0,
                    },
                    {
                        key: "options",
                        label: "Options",
                        sortable: true,
                        class: "text-center",
                        totalled: true,
                        type: "int",
                        total: 0,
                    },
                    {
                        key: "unticketed",
                        label: "Unticketed",
                        sortable: true,
                        class: "text-center",
                        totalled: true,
                        type: "int",
                        total: 0,
                    },
                    // {
                    //     key: "issued_at",
                    //     label: "Date Tickets",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    // {
                    //     key: "updated_by",
                    //     label: "Updated By",
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    // {
                    //     key: "updated_at",
                    //     label: "Updated At",
                    //     sortable: true,
                    //     class: "text-right",
                    // },
                    {
                        key: "startterminal",
                        label: "Start Term",
                        sortable: true,
                        class: "text-center ",
                    },
                    {
                        key: "endterminal",
                        label: "End Term",
                        sortable: true,
                        class: "text-center ",
                    },
                    {
                        key: "fare_total",
                        label: "Sales Total",
                        sortable: true,
                        class: "text-right",
                    },
                    // {
                    //     key: "fare_sell",
                    //     label: "Gross",
                    //     sortable: true,
                    //     class: "text-right",
                    // },
                    // {
                    //     key: "tax",
                    //     label: "Tax",
                    //     sortable: true,
                    //     class: "text-right",
                    // },
                    // {
                    //     key: "fare",
                    //     label: "Net",
                    //     sortable: true,
                    //     class: "text-right",
                    // },
                    {
                        key: "startterminal",
                        label: "Start Term",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "endterminal",
                        label: "End Term",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "message",
                        label: "Message",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "status",
                        label: "Status",
                        sortable: true,
                        class: "text-center ",
                    },
                ],
                badges: [
                    {
                        key: "grouptype",
                        type: "badge",
                        charter: "teal",
                        gds: "danger",
                    },
                    {
                        key: "direction",
                        type: "badge",
                        outbound: "success",
                        inbound: "warning",
                        additional: "info",
                        return: "purple",
                    },
                    {
                        key: "fare_type",
                        type: "badge",
                        Unknown: "white",
                        Negotiated: "warning",
                        Net: "purple",
                        Manual: "secondary",
                        Published: "white",
                        Private: "pink",
                        other: "secondary",
                        'Mixed-ch': "white",
                        'Private-ch': "pink",
                        formatter: (value, key, item) => {
                            if (value) {
                                switch (value.toLowerCase()) {
                                    case "unknown":
                                        return "Unknown";

                                    case "negotiated":
                                        return "Negotiated";

                                    case "net":
                                        return "Net";

                                    case "manual":
                                        return "Manual";

                                    case "published":
                                        return "Published";

                                    case "private":
                                        return "Private";

                                    case "mixed-ch":
                                        return "Mixed-ch";

                                    case "private-ch":
                                        return "Private-ch";

                                    default:
                                        return value;
                                }
                            }
                        },
                    },
                    {
                        key: "classcode",
                        type: "pill",
                        class: "purple",
                    },
                    {
                        key: "locator",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "aircraft",
                        type: "pill",
                        class: "purple",
                    },
                    {
                        key: "free",
                        type: "pill",
                        class: "info",
                    },
                    {
                        key: "booked",
                        type: "pill",
                        class: "success",
                    },
                    {
                        key: "unticketed",
                        type: "pill",
                        class: "danger",
                    },
                    {
                        key: "options",
                        type: "pill",
                        class: "secondary",
                    },
                    {
                        key: "total",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "status",
                        type: "badge",
                        error: "danger",
                        warning: "warning",
                        pending: "warning",
                        ready: "success",
                        released: "success",
                    },
                ],
                items: [],
                selected: [],
            },
        };
    },
    async mounted() {
        this.emailto = this.user.email
        this.agent = this.user.initials

        await this.charters_load()

    },
    computed: {
        releasenotready() {
            let result = true
            if (!this.released) {
                if (this.otc == this.otp) {
                    result = false
                }
            }
            return result
        }
    },
    methods: {
        async charters_load(page) {

            if (page) {
                this.charters.page = page
            }


            this.charters.busy = true
            this.charters.items = []

            let selset = [];
            this.selection.forEach(function (v) {
                selset.push({ id: v.id });
            });

            let variables = {
                selected: selset,
                emailto: this.emailto,
                agent: this.agent,
                apply: false
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation grouppnrs_release(
                            $selected: [GroupPnr_input], 
                            $emailto: String, 
                            $agent: String,
                            $apply: Boolean) {
                            grouppnrs_release(
                                selected: $selected
                                emailto: $emailto
                                agent: $agent
                                apply: $apply
                                ) {
                                    id
                                    grouptype
                                    eventcode
                                    direction
                                    locator                
                                    groupname
                                    source
                                    branch 
                                    agent
                                    notes
                                    routing
                                    startdate
                                    startterminal
                                    endterminal
                                    flightno
                                    classcode
                                    aircraft
                                    fare_type
                                    total
                                    options
                                    booked
                                    free
                                    unticketed
                                    tax
                                    fare
                                    fare_sell
                                    fare_total
                                    status
                                    message
                                    updated_by
                                    updated_at
                                }
                            }        
                    `,
                    variables,
                });
                this.charters.items = response.data.grouppnrs_release
                this.charters.selectall = true

            } catch (error) {
                console.log(error);
                this.message = "<span class='text-danger'>" + error + "</span>";
            }
            this.charters.busy = false
        },

        async releaseit() {

            this.charters.busy = true
            this.message = ""

            let selset = [];
            this.selection.forEach(function (v) {
                selset.push({ id: v.id });
            });

            let variables = {
                selected: selset,
                emailto: this.emailto,
                agent: this.agent,
                apply: true
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
            mutation grouppnrs_release(
                $selected: [GroupPnr_input], 
                $emailto: String, 
                $agent: String,
                $apply: Boolean) {
                grouppnrs_release(
                    selected: $selected
                    emailto: $emailto
                    agent: $agent
                    apply: $apply
                    ) {
                        id
                        grouptype
                        eventcode
                        direction
                        locator                
                        groupname
                        source
                        branch 
                        agent
                        notes
                        routing
                        startdate
                        startterminal
                        endterminal
                        flightno
                        classcode
                        aircraft
                        fare_type
                        total
                        options
                        booked
                        free
                        unticketed
                        tax
                        fare
                        fare_sell
                        fare_total
                        status
                        message
                        updated_by
                        updated_at
                    }
                }        
        `,
                    variables,
                });
                this.charters.items = response.data.grouppnrs_release
                this.released = true

            } catch (error) {
                console.log(error);
                this.message = "<span class='text-danger'>" + error + "</span>";
            }

            this.charters.busy = false

            await this.charters_load();

        },
        async charters_click(a, ss) {

            let state = this.charters;

            switch (a) {
                case "selectall":
                    // state.selectall = !state.selectall;
                    await this.charters_load(0, 0);
                    break;
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                case "refresh":
                case "go":
                    this.component = null;
                    //   this.dateSelector();
                    await this.charters_load();
                    break;
                case "add":
                case "edit":
                    this.component = "ChartersEdit";
                    break;

                case "release":
                    this.component = "CharterRelease";
                    break;

                case "delete":
                    this.deleteit(ss);
                    break;
            }
        },
        async charters_select(ss, tools) {
            console.log("charters_select", ss);

            let state = this.charters;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = [
                    "back",
                    "save",
                    "go",
                    "filter",
                    "add",
                    "export",
                    "release",
                ];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm", "release"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },
        newotp() {
            this.otp = this.$helpers.instanceid();
        },
    },

};
</script>